import { APP_INITIALIZER, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { CommonModule } from '@angular/common'
import { AppComponent } from './app.component';
import { SideNavOuterToolbarModule, SideNavInnerToolbarModule, SingleCardModule } from './layouts';
import { FooterModule, ResetPasswordFormModule, CreateAccountFormModule, ChangePasswordFormModule, LoginFormModule ,HeaderModule} from './shared/components';
import { UnauthenticatedContentModule } from './unauthenticated-content';
import { AppRoutingModule } from './app-routing.module';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DxChartModule, DxDataGridModule, DxDropDownBoxModule, DxDropDownButtonModule, DxFormModule, DxResponsiveBoxModule, DxSelectBoxModule, DxTabPanelModule, DxToolbarModule } from 'devextreme-angular';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { SharedModule } from './shared/modules/shared/shared.module';
import { NotFoundPageComponent } from './pages/not-found-page/not-found-page.component';
import { CoreModule } from './core/core.module';
import { DxButtonModule } from 'devextreme-angular';
import { DxReportViewerModule } from 'devexpress-reporting-angular';
import { NavigationMenuComponent } from './pages/navigation-menu/navigation-menu.component';
import { EditNavigationMenuComponent } from './pages/navigation-menu/edit-navigation-menu/edit-navigation-menu.component';
import { ServerErrorComponent } from './pages/server-error/server-error.component';
import { HomeComponent } from './pages/home/home.component';
import { SharedComponentModule } from './shared-component/shared-component.module';
import { SuperComponent } from './pages/super/super.component';
import { CommComponent } from './comm/comm.component';
import { ChangeEmployeeStatusComponent } from './pages/hr/change-employee-status/change-employee-status.component';
import { ThemeService } from './theme.service';
import { ScreenService } from './shared/services';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { HeadersTitleModule } from './shared/modules/shared/HeadersTitle/HeadersTitle.module';
import { ElectronicReceiptComponent } from './electronic-receipt/electronic-receipt.component';
import { PropertyConfigComponent } from './pages/property-config/property-config.component';
import { EmployeeExtraTimesComponent } from './Interfaces/hr/employee-extra-times/employee-extra-times.component';
import { HRModule } from "src/app/pages/hr/hr.module";
import { ConfigService } from './config-service.service';
import { SharedaccountslookupsComponent } from './shared/sharedaccountslookups/sharedaccountslookups.component';

export function initializeApp(configService: ConfigService) {
  return () => configService.loadConfig();
}

@NgModule({
  declarations: [
    AppComponent,
    NotFoundPageComponent,
    NavigationMenuComponent,
    EditNavigationMenuComponent,
    ServerErrorComponent,
    HomeComponent,
    SuperComponent,
    CommComponent,
    ChangeEmployeeStatusComponent,
    ElectronicReceiptComponent,
    PropertyConfigComponent,
    EmployeeExtraTimesComponent,
  ],
  imports: [
    DxSelectBoxModule,
    DxDropDownBoxModule,
    HeadersTitleModule,
    BrowserAnimationsModule,
    CommonModule,
    BrowserModule,
    SideNavOuterToolbarModule,
    SideNavInnerToolbarModule,
    SingleCardModule,
    FooterModule,
    ResetPasswordFormModule,
    CreateAccountFormModule,
    ChangePasswordFormModule,
    LoginFormModule,
    HeaderModule,
    UnauthenticatedContentModule,
    AppRoutingModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    DxFormModule,
    DxDropDownButtonModule,
    DxToolbarModule,
    SharedModule,
    CoreModule,
    DxButtonModule,
    SharedModule,
    DxReportViewerModule,
    SharedComponentModule,
    DxTabPanelModule,
    DxDataGridModule,
    DxChartModule,
    DxResponsiveBoxModule,
    TranslateModule.forRoot({
        loader: {
            provide: TranslateLoader,
            useFactory: HttpLoaderFactory,
            deps: [HttpClient],
        },
    }),
    HRModule
],
  providers: [ThemeService,
     ScreenService,
  {
    provide: APP_INITIALIZER,
    useFactory: initializeApp,
    deps: [ConfigService],
    multi: true
  }
  
  ]
    
    
    
    ,
    

  bootstrap: [AppComponent]
})
export class AppModule { }

export function HttpLoaderFactory(http: HttpClient): TranslateHttpLoader {
  return new TranslateHttpLoader(http, "./assets/i18n/", ".json");
}
